import {
  IDropdownOption,
  Stack,
  TooltipHost,
  makeStyles,
} from '@fluentui/react';
import { FormHookDropdown } from 'common/components/FormHooksFields';
import React from 'react';
import { FormHookCheckBox } from 'common/components/FormHooksFields/FormHookCheckBox';
import { BusinessUnitCommonData_companyAvailableCurrencies } from '../../__generated__/BusinessUnitCommonData';

const IS_TRACKING_ACCOUNT_TEXT = 'Selectable in payment tracker';

const useStyles = makeStyles(() => ({
  container: {
    width: '70%',
  },
  currency: {
    width: '60%',
  },
  isPrimary: {
    width: '40%',
  },
}));

interface FormFieldsProps {
  baseField: string;
  currencyDisabled: boolean;
  companyCurrencies:
    | BusinessUnitCommonData_companyAvailableCurrencies
    | null
    | undefined;
  isUpdatable: boolean;
  onPrimaryChange: (param: boolean) => void;
}

export const FormFields: React.FC<FormFieldsProps> = ({
  baseField,
  currencyDisabled,
  companyCurrencies,
  isUpdatable,
  onPrimaryChange,
}) => {
  const styles = useStyles();
  const { nodes } = { ...companyCurrencies };

  const currencyOptions: IDropdownOption[] =
    nodes?.map((ele) => {
      const name = ele.name ? ele.name : '';
      const isoCode = ele.isoCode ? ` (${ele.isoCode})` : '';
      return {
        key: ele.id,
        text: `${name}${isoCode}`,
      };
    }) || [];

  return (
    <Stack
      horizontal
      verticalAlign="center"
      className={styles.container}
      tokens={{ childrenGap: 20 }}
    >
      <Stack.Item className={styles.currency}>
        <FormHookDropdown
          name={`${baseField}.currencyId`}
          options={currencyOptions}
          disabled={currencyDisabled}
        />
      </Stack.Item>
      <Stack.Item className={styles.isPrimary}>
        <FormHookCheckBox
          name={`${baseField}.isPrimary`}
          label="Primary"
          disabled={!isUpdatable}
          onChange={(_e, checked) => {
            onPrimaryChange(!!checked);
          }}
        />
      </Stack.Item>
      <Stack.Item className={styles.isPrimary}>
        <TooltipHost content={IS_TRACKING_ACCOUNT_TEXT}>
          <FormHookCheckBox
            name={`${baseField}.isTrackingAccount`}
            label="Tracked"
            disabled={!isUpdatable}
          />
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
};
